import gql from "graphql-tag";

import {type Result} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    legalDocBySlug,
    legalDocBySlugVariables,
} from "./__graphql-types__/legalDocBySlug.ts";

export const LEGAL_DOC_BY_SLUG_QUERY: GqlOperation<legalDocBySlug> = gqlOp(gql`
    query legalDocBySlug($slug: String!) {
        legalDocumentContent(slug: $slug) {
            id
            content
        }
    }
`);

export const useLegalDocBySlugQuery = (
    variables: legalDocBySlugVariables,
): [Result<legalDocBySlug>, () => void] =>
    useQuery(LEGAL_DOC_BY_SLUG_QUERY, {
        variables,
    });
